import React, { useEffect, useContext } from "react";
import { GlobalContext } from "../context/globalContext";
import { CarCarousel } from "../components/_molecules/_car-carousel/CarCarousel";
import { Form } from "../components/_molecules/_form/Form";
import { ArticleSeo } from "../components/_molecules/_articleSeo/ArticleSeo";
import { FormInputSimple } from "../components/_atoms/_form-input-simple/FormInputSimple";

import { LinkSimple } from "../components/_atoms/_link-simple/LinkSimple";
//import { BtnSimple } from "../components/_atoms/_btn-simple/BtnSimple";
import { Tabs } from "../components/_molecules/_tabs/Tabs";

import { HeroMax } from "../components/_molecules/_hero-max/HeroMax";
import { CarData } from "../components/_molecules/_car-data/CarData";
import { DealerSelector } from "../components/_molecules/_dealer-selector/DealerSelector";
import { MaintenanceTabs } from "../components/_molecules/_maintenance-tabs/MaintenanceTabs";

import { GMap } from "../components/_molecules/_gmap/GMap";

import { useConfig } from "../hooks/useConfig";

import { sendAnalytics } from "../utils/analytics";

export const Search = () => {
  //Webservices
  const { wsBSIfinder, wsDealers, wsProducts, wsModels, wsBSIpricesByModel } = useConfig();

  //Matriculas
  //BSI+Plus : 1861LLT
  //Precioscerrados: 5555GGG
  //MINI: 7260FNX

  //Vehículo con BSI y Precios Cerrados
  //4832JCG
  //Vehículo solo BSI (no tienen Precios Cerrados)
  //1110LKG
  //Vehículo solo Precios Cerrados (no tiene MSI)
  //4208CZP

  const { state, setState } = useContext(GlobalContext);

  const {
    form,
    inputValue,
    provinceValue,
    outlet,
    carSpecs,
    dealers,
    productsAvailable,
    step,
    errorMessage,
    defaultLat,
    defaultLong,
    modal,
    carousel,
    brand,
  } = state;

  //Buscamos los datos del dealer si nos dan el buno en la url
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const bunoParam = urlParams.get("buno");
  const heroParam = urlParams.get("hero");

  //For some reasing the load event is loading before GTM
  //so we create a promise to check if GTM is loaded before sending the event
  const waitForGTMLoad = () => {
    return new Promise(function (resolve, reject) {
      (function waitForIt() {
        if (window.dataLayer[2] !== undefined) {
          return resolve(true);
        }
        setTimeout(waitForIt, 100);
      })();
    });
  };

  useEffect(() => {
    //GTM
    //Si no tenemos Buno enviamos el evento, más adelante
    //enviaremos el evento con datos del dealer si tenemos el buno
    if (!bunoParam) {
      waitForGTMLoad().then(function (response) {
        window.dataLayer.push({
          event: "sc_search_page",
        });
      });
    }
  }, [brand]);

  useEffect(() => {
    if (!!bunoParam) {
      fetch(wsDealers)
        .then((resp) => resp.json())
        .then((dataDealer) => {
          const dataDealerArray = Object.values(dataDealer.Records);

          const dealerFound = dataDealerArray.find((dealer) => {
            if (dealer.id_outlet === bunoParam) {
              return dealer;
            } else {
              return;
            }
          });

          //GTM
          waitForGTMLoad().then(function (response) {
            window.dataLayer.push({
              event: "sc_search_page",
              provincia: dealerFound.nombre_provincia,
              taller: dealerFound.nombre,
              buno: dealerFound.id_outlet,
            });
          });

          setState({
            ...state,
            outlet: dealerFound.id_outlet,
            outletName: dealerFound.nombre,
            provinceValue: dealerFound.nombre_provincia,
          });
        });
    }
  }, [bunoParam]);

  //TODO Turn this into a hook
  const content = require(`../data/${brand}-lang.es.json`);
  const searchTxt = content.search;
  document.documentElement.classList = brand;

  //Mostramos el carrusel
  const showCarousel = () => {
    fetch(wsModels)
      .then((resp) => resp.json())
      .then((data) => {
        const { Records } = data;

        setState({
          ...state,
          outlet: bunoParam ? bunoParam : "",
          carousel: Records,
        });

        // window.scrollTo({
        //   top: 3000,
        //   left: 0,
        //   behavior: "smooth",
        // });
      });

    sendAnalytics("click_busqueda_modelo", "");
  };

  //Llamamos al WS de BSI Finder
  const getLicensePlate = (e) => {
    e.preventDefault();

    setState({ ...state, form: "loading" });

    fetch(wsBSIfinder + inputValue)
      .then((resp) => resp.json())
      .then((dataBSI) => {
        //Guardamos el resultado en variable para luego poder actualizar el estado
        const { brand: brandFromWS } = dataBSI;

        // console.log(dataBSI);

        if (dataBSI.longVin) {
          //Pedimos las provincias y los talleres, guardamos todo en State y marcamos el estado del formulario
          if (
            brandFromWS.toUpperCase() === brand.toUpperCase() ||
            (brandFromWS.toUpperCase() === "BMW I" && brand.toUpperCase() === "BMW")
          ) {
            fetch(wsDealers)
              .then((resp) => resp.json())
              .then((dataDealer) => {
                setState({
                  ...state,
                  dealers: dataDealer.Records,
                  carSpecs: dataBSI,
                  form: "success",
                  step: 1,
                });
              });
            //GTM
            window.dataLayer.push({
              event: "sc_busqueda_matriculaOK",
              model: dataBSI.ecode,
            });
          } else {
            //Error
            setState({
              ...state,
              form: "failure",
              errorMessage: [searchTxt.formFailureBrand],
            });
            //GTM
            window.dataLayer.push({
              event: "sc_busqueda_matriculaKO",
              message: searchTxt.formFailureBrand,
            });
          }
        } else if (dataBSI.response) {
          //Error matricula no encontrada
          setState({
            ...state,
            form: "failure",
            errorMessage: [searchTxt.formFailureNotFound],
          });

          //GTM
          window.dataLayer.push({
            event: "sc_busqueda_matriculaKO",
            message: dataBSI.response,
          });
        } else {
          //Error genérico
          setState({
            ...state,
            form: "failure",
            errorMessage: [searchTxt.formFailure],
          });

          //GTM
          window.dataLayer.push({
            event: "sc_busqueda_matriculaKO",
            message: searchTxt.formFailure,
          });
        }
      });

    sendAnalytics("click_busqueda_matricula", JSON.stringify({ inputValue }));
  };

  //Activamos el input
  const enableInput = (e) => {
    if (form !== "initial" && form !== "failure") {
      e.preventDefault();
    }
    //setState({ ...state, form: "initial" });
  };

  //Guardamos el valor del input en el estado
  const saveInputValue = (e) => {
    let tempValue = e.target.value;

    tempValue = tempValue.replace(/[^A-Za-z0-9\s!?]/g, "");
    tempValue = tempValue.replaceAll(" ", "");

    tempValue = tempValue.toUpperCase();

    setState({ ...state, inputValue: tempValue });
  };

  //Guardamos el valor del input en el estado
  const saveProvince = (e) => {
    setState({ ...state, provinceValue: e.target.value, outlet: "" });
  };

  //Guardamos el valor del outlet - Versión boton ( Desactivada ahora mismo por el RMTESP-1241)
  const saveOutlet = (e) => {
    const outletBuno = e.target.htmlFor;
    const dealerData = dealers.find((item) => {
      if (item.id_outlet === outletBuno) {
        return item;
      } else {
        return;
      }
    });

    setState({ ...state, outlet: outletBuno, outletName: dealerData.nombre });

    //GTM
    window.dataLayer.push({
      event: "sc_seleccion_taller",
      model: carSpecs.ecode,
      provincia: provinceValue,
      taller: dealerData.nombre,
      buno: dealerData.id_outlet,
    });
  };

  //Guardamos el valor del outlet - Versión Select
  const saveOutletSelect = (e) => {
    const outletBuno = e.target.value;
    const dealerData = dealers.find((item) => {
      if (item.id_outlet === outletBuno) {
        return item;
      } else {
        return;
      }
    });

    setState({ ...state, outlet: outletBuno, outletName: dealerData.nombre });

    //GTM
    window.dataLayer.push({
      event: "sc_seleccion_taller",
      model: carSpecs.ecode,
      provincia: provinceValue,
      taller: dealerData.nombre,
      buno: dealerData.id_outlet,
    });
  };

  const backToSearch = () => {
    setState({
      ...state,
      form: "initial",
      step: 0,
      outlet: bunoParam ? bunoParam : "",
      provinceValue: "",
      inputValue: "",
      carSpecs: "",
    });
  };

  //Sacamos productos de Precios cerrados
  const getProducts = (e) => {
    if (e) {
      e.preventDefault();
    }

    const { outlet } = state;
    const { ecode, longVin } = carSpecs;

    fetch(wsProducts + "&idoutlet=" + outlet + "&idmodelo=" + ecode + "&bastidor=" + longVin)
      .then((resp) => resp.json())
      .then((data) => {
        setState({ ...state, step: 2, productsAvailable: data.Records });
      });
  };

  // const moveGMapCenter = (e) => {
  //   setState({ ...state, defaultLat: 38.34517, defaultLong: -0.48149 });
  // };

  const saveOutletFromMap = (outletID) => {
    setState({ ...state, outlet: outletID });

    window.dataLayer.push({
      event: " sc_seleccion_taller",
      model: carSpecs.ecode,
      provincia: provinceValue,
      taller: outletID,
    });
  };

  const toggleModal = () => {
    const { modal } = state;

    if (modal) {
      setState({ ...state, modal: false });
    } else {
      setState({ ...state, modal: true });
    }
  };
  //Ocultamos el hero
  useEffect(() => {
    if (heroParam) {
      showCarousel();
    }
  }, [heroParam]);

  //Si cambiamos el outlet y tenemos VIN, buscamos los precios.
  //Se usa para poder seleccionar el buno o cogerlo de parámetro
  useEffect(() => {
    if (outlet !== "" && carSpecs.longVin !== undefined) {
      getProducts();
    }
  }, [outlet]);

  //Si cambiamos los datos del coche y tenemos VIN, buscamos los precios
  //Se usa para poder seleccionar el buno o cogerlo de parámetro
  useEffect(() => {
    if (outlet !== "" && carSpecs.longVin !== undefined) {
      getProducts();
    }
  }, [carSpecs]);
  //Guardamos todo en localstorage
  // useEffect(() => {
  //   localStorage.setItem("bmw_calculator", JSON.stringify(state));
  // }, [state]);

  const saveFormCarousel = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    //Select de motorización
    if (name === "vin") {
      //To do..buscar dentro de los datos del WS, no del select

      const modelRange = target.options[e.target.options.selectedIndex].attributes[0].value;
      const serie = "Serie " + target.options[e.target.options.selectedIndex].attributes[3].value;
      const date = target.options[e.target.options.selectedIndex].attributes[5].value;
      const model = target.options[e.target.options.selectedIndex].text;
      const groupID = target.options[e.target.options.selectedIndex].attributes[2].value;
      const fuel = target.options[e.target.options.selectedIndex].attributes[1].value;

      //Calculamos la antiguedad
      // console.log(item);
      let show24 = false;
      if (date === "0") {
        show24 = true;
      } else {
        const sopDate = new Date(date); // Crear un objeto Date directamente desde el string de fecha
        const currentDate = new Date();
        const differenceInMonths =
          (currentDate.getFullYear() - sopDate.getFullYear()) * 12 + currentDate.getMonth() - sopDate.getMonth();
        differenceInMonths >= 24 ? (show24 = true) : (show24 = false);
      }

      setState({
        ...state,
        //dealers: dataDealer.Records,
        // form: "success",
        // step: 1,
        carSpecs: {
          code: "",
          brand: brand,
          ecode: modelRange,
          brandName: serie + " " + model,
          longVin: target.value,
          fuel: fuel,
          groupID: groupID,
          carousel: true,
          show24: show24,

          //tabs: tabsValues,
        },
      });
      //Select de antiguedad
    } else {
      const groupID = carSpecs.groupID;
      const fuel = carSpecs.fuel;
      const age = value;
      fetch(wsBSIpricesByModel + "?group=" + groupID + "&fuel=" + fuel + "&age=" + age)
        .then((resp) => resp.json())
        .then((dataBSIprices) => {
          fetch(wsDealers)
            .then((resp) => resp.json())
            .then((dataDealer) => {
              const tabsValues = dataBSIprices.Records;

              //marcamos la fecha de matriculación como la de hoy y le restamos X años segun lo indicado en el selector
              const subtractYears = age === "VO" ? 2.1 : 0;

              let regDate = new Date();
              const dd = String(regDate.getDate()).padStart(2, "0");
              const mm = String(regDate.getMonth() + 1).padStart(2, "0"); //January is 0!
              const yyyy = regDate.getFullYear();

              regDate = `${dd}.${mm}.${yyyy - subtractYears}`;

              setState({
                ...state,
                dealers: dataDealer.Records,
                // form: "success",
                // step: 1,
                carSpecs: {
                  ...carSpecs,
                  tabs: tabsValues,
                  firstRegistrationDate: regDate,
                },
              });
            });
        });
    }
  };

  const getPricesFromCarousel = (e) => {
    e.preventDefault();

    //GTM
    window.dataLayer.push({
      event: "sc_busqueda_modelo",
      model: carSpecs.ecode,
    });

    setState({
      ...state,
      form: "success",
      step: 1,
    });
  };

  return (
    <main>
      <section
        className={
          form === "success" || (!!carousel && form === "initial")
            ? "animate-out-slide-top animate-out-slide-top--active"
            : "animate-out-slide-top"
        }>
        {heroParam !== "hide" && (
          <HeroMax
            img={`./img/${brand}/hero-max-new.png`}
            alt={searchTxt.title}
            css={!!carousel && form === "initial" && "hero-max--collapsed"}
            acss={
              (!!carousel && heroParam === "hide" && "hero-max--hidden") ||
              (!!carousel && form === "initial" && "hero-max--collapsed")
            }
            decorative={true}>
            <h1 className="h3">{searchTxt.title}</h1>
            <p>{searchTxt.desc}</p>
            <Form css="form--simple form--simple--dark" onSubmit={getLicensePlate}>
              <FormInputSimple
                label={searchTxt.input}
                name="license_plate"
                type="text"
                addon="right"
                addonText={form === "loading" || form === "loaded" ? "#close" : "#search"}
                placeholder={searchTxt.input}
                disabled={form === "loading" || form === "loaded" ? true : false}
                disabledAddon={form === "loading" ? true : false}
                focus={form === "initial" ? true : false}
                onClick={enableInput}
                onChange={saveInputValue}
                value={inputValue}
                validation={form === "failure" ? "form__group--danger" : ""}
                error={errorMessage}
                maxLength="8"
              />
            </Form>
          </HeroMax>
        )}
        {brand === "bmw" && (
          <ArticleSeo
            title_1={"DESCUBRE LOS BENEFICIOS EXCLUSIVOS DE LA CALCULADORA DE MANTENIMIENTO BMW."}
            text_1={
              "¿Quieres brindarle el mejor mantenimiento a tu BMW? ¡Con nuestra calculadora de mantenimiento BMW, calcula el coste de nuestros servicios de forma rápida y sencilla! Introduce tu matrícula para explorar ​todos los precios y las ofertas disponibles en nuestros Talleres Autorizados BMW."
            }
            text_2={
              "Disponemos  una gama completa de promociones y precios para todos los servicios de mantenimiento que tu BMW merece. Por ejemplo, la revisión general, el cambio de aceite, el cambio de líquido de frenos, ¡y muchos otros! Con nuestra calculadora de mantenimiento, accede a información relevante sobre cada servicio de nuestros Talleres Autorizados BMW, donde te brindaremos el mejor cuidado para tu coche."
            }
            title_2={"EXPLORA NUESTROS PAQUETES DE MANTENIMIENTO BMW AL MEJOR PRECIO."}
            text_3={
              "En BMW, deseamos ofrecerte los mejores servicios de calidad a un precio competitivo. Por ello, puedes elegir la opción que más se adapta a tus necesidades:"
            }
            list_1={
              <>
                <strong>Paquetes de mantenimiento Service Inclusive</strong> por el tiempo y kilometraje que desees.
              </>
            }
            list_2={
              <>
                Operaciones individuales con el <strong>Programa Precios Cerrados.</strong>
              </>
            }
            text_4={
              "¡Reserva ahora mismo el servicio que necesitas en cualquiera de nuestros Talleres Autorizados BMW! Nuestro equipo de expertos te proporcionará el asesoramiento y la atención personalizada que necesitas para mantener tu vehículo como nuevo en todo momento. En BMW, estamos comprometidos con ofrecerte una atención rápida, eficaz y brindarte siempre la mejor experiencia de conducción."
            }
          />
        )}
        {brand === 'mini' && 
        <ArticleSeo
          title_1={"DESCUBRE LAS VENTAJAS EXCLUSIVAS DE LA CALCULADORA DE MANTENIMIENTO DE MINI."}
          text_1={"¿Estás buscando cómo brindarle los mejores cuidados a tu vehículo MINI? ¡Con nuestra calculadora de mantenimiento MINI, obtén los precios de forma instantánea! Indica tu matrícula para descubrir todos los beneficios y las promociones."}
          text_2={"¿Necesitas cambiar el aceite? ¿Una revisión general? ¿O quizás un cambio de líquido de frenos? Con nuestra calculadora, accede a información detallada sobre cada servicio, garantizando el mejor cuidado para tu vehículo."}
          title_2={"EXPLORA NUESTRA AMPLIA VARIEDAD DE SERVICIOS A UN PRECIO MUY COMPETITIVO."}
          text_3={"En MINI, entendemos la importancia de brindar un servicio de calidad a precios accesibles. Por eso, nuestra calculadora de mantenimiento MINI te permite conocer el precio de una amplia gama de servicios, desde los más básicos hasta los más especializados. Elige la opción que más se adapta a tus necesidades:"}
          list_1={<><strong>Paquetes de mantenimiento Service Inclusive</strong> por el tiempo y kilometraje que desees.</>}
          list_2={<><strong>Operaciones individuales con el Programa Precios Cerrados.</strong></>}
          text_4={"Con nuestra calculadora de mantenimiento MINI, también podrás aprovechar nuestras promociones exclusivas. ¡Pide cita ahora para realizar tu revisión en uno de nuestros Talleres Autorizados MINI! Nuestro equipo de profesionales te proporcionará el asesoramiento y la atención personalizada que necesitas para mantener tu vehículo en óptimas condiciones. En MINI, nos comprometemos a brindarte la mejor experiencia de conducción, desde el primer día hasta el último."}
        /> }
      </section>
      {!!carousel && form === "initial" && (
        <div className="hero-sub">
          <div className="container-grid">
            <Tabs
              tabList={carousel.map((item, i) => {
                return carousel[i].short_name;
              })}
              tabContent={carousel.map((item, i) => {
                return (
                  <CarCarousel
                    onSubmit={getPricesFromCarousel}
                    onChange={saveFormCarousel}
                    data={carousel[i].models}
                    show24={carSpecs.show24}
                  />
                );
              })}
            />
          </div>
        </div>
      )}
      {form === "success" && (
        <>
          <section>
            <div className="container-grid">
              <CarData
                brand={brand}
                tabs={carSpecs.tabs}
                vin={carSpecs.longVin}
                model={`${carSpecs.brand} ${carSpecs.brandName} `}
                ecode={carSpecs.ecode}
                plate={inputValue}
                onClick={backToSearch}
                showPacket={step === 2 ? true : false}
                name={carSpecs.name}
                type={carSpecs.type}
                business={carSpecs.business}
                firstRegistrationDate={carSpecs.firstRegistrationDate}></CarData>
            </div>
            {outlet === "" && (
              <div className="container-grid" style={{ position: "relative" }}>
                <div data-col-md="8">
                  <DealerSelector
                    onChange={saveProvince}
                    onClick={saveOutlet}
                    onChangeSelect={saveOutletSelect}
                    dealers={dealers}
                    provinceSelected={provinceValue}
                    modalClick={toggleModal}
                    showButton={outlet !== "" && outlet !== undefined ? true : false}
                    title={searchTxt.dealerFinderTitle}
                    subtitle={searchTxt.dealerFinderSubTitle}></DealerSelector>
                </div>
                {/*modal && (
                  <GMap
                    pointsData={dealers}
                    defaultLat={defaultLat}
                    defaultLong={defaultLong}
                    onClick={saveOutletFromMap}
                    closeClick={toggleModal}
                  />
                )*/}
              </div>
            )}

            {outlet !== "" && (
              <MaintenanceTabs
                showClosedPrices={productsAvailable != "" ? true : false}
                bsiData={carSpecs}
                closedPricesData={productsAvailable}
              />
            )}
          </section>
        </>
      )}
    </main>
  );
};
